export enum TNotificationsCategory {
    THREE_D_SECURE_OTP = 'THREE_D_SECURE_OTP',
    ITSP_OTP = 'ITSP_OTP',
}

export interface INotifications {
    id: string;
    language: string;
    title: string;
    description: string;
    body: string;
    card_product_id: string;
    created: number;
    modified: boolean;
    channel: string;
    active: boolean;
}

export interface INotificationsQueryParams {
    limit: number;
    after: string;
    name: string;
    mcc_id: string;
}

export interface INotificationCardProductDropdown {
    id: string;
    description: string;
}

export type IMutateNotifications = Omit<INotifications, 'created' | 'modified'>;
